document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('cart-offer-popup');

  if (!popup) return;

  const amount = popup.querySelector('#cart-offer-amount');
  const code = popup.querySelector('#cart-offer-code');
  const closeButton = popup.querySelector('.cart-offer-close');
  const overlay = popup.querySelector('.cart-offer-overlay');

  function closePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  const denonOffers = {
    '250bt':  { amount: '₹200 OFF',   code: 'DENON250BT' },
    '580bt':  { amount: '₹400 OFF',   code: 'DENON580BT' },
    '760h':   { amount: '₹500 OFF',   code: 'DENON760H' },
    '1800h':  { amount: '₹700 OFF',   code: 'DENON1800H' },
    '970h':   { amount: '₹1,000 OFF', code: 'DENON970H' },
    '2800h':  { amount: '₹1,000 OFF', code: 'DENON2800H' },
    '2900h':  { amount: '₹1,500 OFF', code: 'DENON2900H' },
    '3800h':  { amount: '₹1,200 OFF', code: 'DENON3800H' },
    '3900h':  { amount: '₹1,500 OFF', code: 'DENON3900H' },
    '4800h':  { amount: '₹2,000 OFF', code: 'DENON4800H' },
    '6800h':  { amount: '₹2,200 OFF', code: 'DENON6800H' }
  };

  function showOffer(cartTotal, isDenonAVR, productHandle) {
    let offerAmount = '';
    let couponCode = '';

    if (isDenonAVR) {
      const handle = (productHandle || '').toLowerCase();

      const modelKey = Object.keys(denonOffers).find(function (model) {
        return handle.includes(model);
      });

      const offer = modelKey ? denonOffers[modelKey] : null;

      if (offer) {
        offerAmount = offer.amount;
        couponCode = offer.code;
      }
    }

    // Use the existing cart offers for non-Denon products
    // and as a fallback if a Denon model is not recognised.
    if (!couponCode) {
      if (cartTotal < 5000000) {
        offerAmount = '₹500 OFF';
        couponCode = 'CART500';
      } else if (cartTotal < 10000000) {
        offerAmount = '₹2,000 OFF';
        couponCode = 'CART2000';
      } else if (cartTotal < 20000000) {
        offerAmount = '₹5,000 OFF';
        couponCode = 'CART5000';
      } else if (cartTotal < 30000000) {
        offerAmount = '₹8,000 OFF';
        couponCode = 'CART8000';
      } else if (cartTotal < 40000000) {
        offerAmount = '₹10,000 OFF';
        couponCode = 'CART10000';
      } else {
        offerAmount = '₹15,000 OFF';
        couponCode = 'CART15000';
      }
    }

    amount.textContent = offerAmount;
    code.textContent = couponCode;

    popup.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  async function checkCart(isDenonAVR, productHandle) {
    try {
      const response = await fetch('/cart.js');

      if (!response.ok) return;

      const cart = await response.json();

      if (cart.item_count > 0) {
        showOffer(cart.total_price, isDenonAVR, productHandle);
      }
    } catch (error) {
      console.error('Cart offer popup error:', error);
    }
  }

  // Detect Add to Cart
  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form || !form.matches('form[action*="/cart/add"]')) {
      return;
    }

    const productForm = form.closest('product-form');

    const isDenonAVR =
      !!productForm &&
      productForm.dataset.denonAvr === 'true';

    const productHandle =
      productForm?.dataset.productHandle || '';

    setTimeout(function () {
      checkCart(isDenonAVR, productHandle);
    }, 1500);
  });

  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }
});

// Copy coupon code
document.addEventListener('click', async function (event) {
  const copyButton = event.target.closest('.cart-offer-copy');

  if (!copyButton) return;

  const codeElement = document.getElementById('cart-offer-code');
  if (!codeElement) return;

  const couponCode = codeElement.textContent.trim();

  try {
    await navigator.clipboard.writeText(couponCode);

    const originalText = copyButton.innerHTML;
    copyButton.textContent = '✓';
    copyButton.setAttribute('aria-label', 'Coupon code copied');

    setTimeout(function () {
      copyButton.innerHTML = originalText;
      copyButton.setAttribute('aria-label', 'Copy coupon code');
    }, 1800);

  } catch (error) {
    const textArea = document.createElement('textarea');
    textArea.value = couponCode;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.select();

    const copied = document.execCommand('copy');
    textArea.remove();

    if (copied) {
      const originalText = copyButton.innerHTML;
      copyButton.textContent = '✓';

      setTimeout(function () {
        copyButton.innerHTML = originalText;
        copyButton.setAttribute('aria-label', 'Copy coupon code');
      }, 1800);
    } else {
      window.prompt('Copy your coupon code:', couponCode);
    }
  }
});